export default __webpack_public_path__ + "static/media/Nin.e5daec6f.png";